module.exports = __webpack_public_path__ + "static/left-7ded8b877146433c6071ecc1f8aa1c71.png";